// extracted by mini-css-extract-plugin
export default {"FancyImageElement":"FancyImageElement_FancyImageElement__ELRcF","wrapper":"FancyImageElement_wrapper__NHa9X","selected":"FancyImageElement_selected__86h5L"};